import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { formatDateLocal } from '../utils/reportDateRange';


export const FETCH_PLAYERWISE_SALE_REQUEST = 'FETCH_PLAYERWISE_SALE_REQUEST';
export const FETCH_PLAYERWISE_SALE_SUCCESS = 'FETCH_PLAYERWISE_SALE_SUCCESS';
export const FETCH_PLAYERWISE_SALE_FAILURE = 'FETCH_PLAYERWISE_SALE_FAILURE';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;


export const getPlayerWiseSaleReport = ({ startDate, endDate, companyId, silent = false }) => async (dispatch) => {
    if (!silent) {
      dispatch({ type: FETCH_PLAYERWISE_SALE_REQUEST });
    }

    try {
       console.log("getPlayerWiseSaleReport sd",startDate,"  ld ",endDate)
       const role = getLoggedInUserRole();
       const loggedInUsername = getLoggedInUsername();

      const response = await axios.post(`${base_url}`, {
        apiName: 'reporting',
        command: 'getPlayerWiseSaleReport',
        startDate: formatDateLocal(startDate),
        endDate: formatDateLocal(endDate),
        company_id: companyId,
        role,
        loggedInUserRole: role,
        loggedInUsername,
      });
      console.log("getPlayerWiseSaleReport " ,response);
      dispatch({
        type: FETCH_PLAYERWISE_SALE_SUCCESS,
        payload: response.data.data, // Ensure backend returns a `data` field
      });
    } catch (error) {
      if (!silent) {
        dispatch({
          type: FETCH_PLAYERWISE_SALE_FAILURE,
          payload: error.response?.data?.message || 'Failed to fetch sale report',
        });
      }
    }
  };
  
  